<div class="create-group">
    <header class="create-group__header">
        <h2 mat-dialog-title autoTranslate>{{ isEdit ? 'Editar grupo' : 'Novo grupo' }}</h2>
        <button
            type="button"
            mat-icon-button
            mat-dialog-close
            [attr.aria-label]="'Fechar' | autoTranslate"
        >
            <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
        </button>
    </header>

    <mat-dialog-content class="create-group__content">
        <mat-form-field appearance="outline" class="create-group__name">
            <mat-label autoTranslate>Nome do grupo</mat-label>
            <input matInput [(ngModel)]="name" maxlength="80" />
        </mat-form-field>

        <div class="create-group__people-head">
            <p class="create-group__section" autoTranslate>Participantes</p>
            <span class="create-group__count">{{ selectedCount }}</span>
        </div>

        <div class="create-group__search">
            <mat-icon class="create-group__search-icon" svgIcon="heroicons_outline:magnifying-glass"></mat-icon>
            <input
                type="search"
                class="create-group__search-input"
                [(ngModel)]="search"
                [placeholder]="'Pesquisar contatos' | autoTranslate"
                [attr.aria-label]="'Pesquisar contatos' | autoTranslate"
            />
        </div>

        <div class="create-group__list">
            <ng-container *ngIf="groupedContacts.length > 0; else noContacts">
                <section *ngFor="let company of groupedContacts; trackBy: trackCompany" class="create-group__company">
                    <h3 class="create-group__company-name" *ngIf="company.companyName">{{ company.companyName }}</h3>
                    <h3 class="create-group__company-name" *ngIf="!company.companyName" autoTranslate>Administração</h3>

                    <div *ngFor="let role of company.roles; trackBy: trackRole" class="create-group__role">
                        <div
                            class="create-group__role-head"
                            role="button"
                            tabindex="0"
                            (click)="toggleRole(role, !isRoleFullySelected(role))"
                            (keydown.enter)="toggleRole(role, !isRoleFullySelected(role))"
                            (keydown.space)="$event.preventDefault(); toggleRole(role, !isRoleFullySelected(role))"
                        >
                            <mat-checkbox
                                [checked]="isRoleFullySelected(role)"
                                [indeterminate]="isRolePartiallySelected(role)"
                                (click)="$event.stopPropagation()"
                                (change)="toggleRole(role, $event.checked)"
                            ></mat-checkbox>
                            <span class="create-group__role-label">
                                {{ role.roleLabel | autoTranslate }} ({{ role.contacts.length }})
                            </span>
                        </div>

                        <div
                            *ngFor="let c of role.contacts; trackBy: trackContact"
                            class="create-group__person"
                            role="button"
                            tabindex="0"
                            (click)="toggle(c.user_id, !isSelected(c.user_id))"
                            (keydown.enter)="toggle(c.user_id, !isSelected(c.user_id))"
                            (keydown.space)="$event.preventDefault(); toggle(c.user_id, !isSelected(c.user_id))"
                        >
                            <mat-checkbox
                                [checked]="isSelected(c.user_id)"
                                (click)="$event.stopPropagation()"
                                (change)="toggle(c.user_id, $event.checked)"
                            ></mat-checkbox>
                            <span
                                class="create-group__avatar"
                                [class.create-group__avatar--online]="c.status === 'AVAILABLE'"
                                [class.create-group__avatar--busy]="c.status === 'BUSY'"
                                [class.create-group__avatar--offline]="!c.is_online"
                            >
                                {{ getInitials(c.name) }}
                            </span>
                            <span class="create-group__person-meta">
                                <span class="create-group__person-name">{{ c.name }}</span>
                                <span class="create-group__badge">{{ profileLabel(c.profile_type, c.role_name) | autoTranslate }}</span>
                            </span>
                        </div>
                    </div>
                </section>
            </ng-container>
            <ng-template #noContacts>
                <p class="create-group__empty" autoTranslate>Nenhum contato encontrado.</p>
            </ng-template>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="create-group__actions">
        <ng-container *ngIf="isEdit">
            <button
                *hasPermission="['CONVERSATION_DELETE', 'CONVERSATION_CREATE']"
                type="button"
                mat-stroked-button
                color="warn"
                class="create-group__delete"
                [disabled]="saving || deleting"
                (click)="confirmDelete()"
            >
                <span autoTranslate>Excluir</span>
            </button>
        </ng-container>
        <span class="create-group__actions-spacer"></span>
        <button mat-button mat-dialog-close [disabled]="saving || deleting" autoTranslate>Cancelar</button>
        <button
            mat-flat-button
            color="primary"
            [disabled]="!name.trim() || saving || deleting"
            (click)="save()"
        >
            <span autoTranslate>{{ isEdit ? 'Salvar' : 'Criar' }}</span>
        </button>
    </mat-dialog-actions>
</div>
